import { render, staticRenderFns } from "./NotificationPreview.vue?vue&type=template&id=686146f6&scoped=true"
import script from "./NotificationPreview.vue?vue&type=script&lang=js"
export * from "./NotificationPreview.vue?vue&type=script&lang=js"
import style0 from "./NotificationPreview.vue?vue&type=style&index=0&id=686146f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686146f6",
  null
  
)

export default component.exports